import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FeatureBand from './FeatureBand.jsx';
import FoxFigure from '../../components/illustrations/FoxFigure.jsx';
import { FEATURES } from '../../content/features.js';
import { CONTACT_PATH } from '../../content/contacts.js';
import './WhatWeDo.css';

/**
 * "Økonomisjefen du ikke har tid til å være": an intro band (the fox, the title, the hats you
 * already wear, what Revetall does and the button), then one band per feature.
 * @returns {JSX.Element} What-we-do section
 */
function WhatWeDo() {
  const { t } = useTranslation();

  return (
    <section className="what-we-do" id="hva-vi-gjor" aria-labelledby="what-we-do-title">
      <div className="what-we-do-intro">
        <div className="what-we-do-figure">
          <FoxFigure />
        </div>
        <h2 className="what-we-do-title" id="what-we-do-title">
          <span className="what-we-do-highlight">
            {t('whatWeDo.titleHighlight')}
            <svg
              className="what-we-do-swoosh"
              viewBox="0 0 300 16"
              preserveAspectRatio="none"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M4 11 C 60 4, 170 2, 296 8" />
            </svg>
          </span>{' '}
          {t('whatWeDo.titleRest')}
        </h2>
        <p className="what-we-do-lead">
          <span>{t('whatWeDo.lead')}</span>{' '}
          <strong>{t('whatWeDo.leadEmphasis')}</strong>
        </p>
        <Link to={CONTACT_PATH} className="button button-primary button-large">
          {t('whatWeDo.cta')}
        </Link>
      </div>
      {FEATURES.map((feature, index) => (
        <FeatureBand key={feature.id} feature={feature} index={index} />
      ))}
    </section>
  );
}

export default WhatWeDo;
